import React, {ReactNode} from 'react';
import {Animated, TouchableWithoutFeedback, View} from 'react-native';

import {getModalStyle} from '/component/partial/PopupBackground/PopupBackground.util';
import {POPUP_STATE_HIDDEN} from '/enum/popupState.enum';
import testProperties from '/util/testing/testProperties';

import {usePopupBackground} from './PopupBackground.hook';
import {styles} from './PopupBackground.style';

interface PopupBackgroundProps {
  children: ReactNode;
  avoidable: boolean;
  modalState: string;
  onAnimationComplete: () => void;
  hidePopup: () => void;
  showFullModal: boolean;
  showSuccessModal: boolean;
}

export const PopupBackground: React.FC<PopupBackgroundProps> = ({
  children = null,
  avoidable = true,
  modalState = POPUP_STATE_HIDDEN,
  onAnimationComplete = () => {},
  hidePopup = () => {},
  showFullModal = false,
  showSuccessModal = false,
}) => {
  const {fadeAnim} = usePopupBackground({modalState, onAnimationComplete});

  if (modalState === POPUP_STATE_HIDDEN) {
    return null;
  }

  return (
    <Animated.View
      accessibilityViewIsModal={true}
      style={[styles.container, {opacity: fadeAnim.current}]}>
      <View style={styles.center}>
        <View style={styles.behind}>
          <TouchableWithoutFeedback
            disabled={!avoidable}
            accessible={false}
            importantForAccessibility="no"
            onPress={hidePopup}
            {...testProperties(null, true)}>
            <View style={styles.touchableBackground} />
          </TouchableWithoutFeedback>
        </View>
        <View style={[getModalStyle({showFullModal, showSuccessModal})]}>
          {children}
        </View>
      </View>
    </Animated.View>
  );
};

export default PopupBackground;
